import { UserDeviceEntity } from '../entities/UserDevice';
import { authResource } from './Auth';
import { paginatedSchema } from '../utils/schemas';
export const AccountDeviceResource = authResource({
    path: '/accounts/:accountId/devices/:userDeviceId',
    schema: UserDeviceEntity
}).extend('getList', {
    schema: paginatedSchema(UserDeviceEntity)
});
